// Deleivery & Waste Record Count Actions
export const HOME_RECORDS_COUNT_LOAD = 'HOME_RECORDS_COUNT_LOAD'
export const loadRecordsCount = (
  accountId: string,
  projectId: string,
  moduleName: string,
  period: string,
  filterState: any
) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD,
    accountId,
    projectId,
    moduleName,
    period,
    filterState
  }
}

export const HOME_RECORDS_COUNT_LOAD_SUCCESS = 'HOME_RECORDS_COUNT_LOAD_SUCCESS'
export const loadRecordsCountSuccess = (moduleName, period, recordsCount) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD_SUCCESS,
    moduleName,
    period,
    recordsCount
  }
}

export const HOME_RECORDS_COUNT_LOAD_FAILURE = 'HOME_RECORDS_COUNT_LOAD_FAILURE'
export const loadRecordsCountFailure = (moduleName, period, error) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD_FAILURE,
    moduleName,
    period,
    error
  }
}

// Alert Actions
export const HOME_ENABLED_ALERT_RULES_COUNT_LOAD =
  'HOME_ENABLED_ALERT_RULES_COUNT_LOAD'
export const loadEnabledAlertRulesCount = (
  accountId: string,
  projectId: string
) => {
  return {
    type: HOME_ENABLED_ALERT_RULES_COUNT_LOAD,
    accountId,
    projectId
  }
}

export const HOME_ENABLED_ALERT_RULES_COUNT_LOAD_SUCCESS =
  'HOME_ENABLED_ALERT_RULES_COUNT_LOAD_SUCCESS'
export const loadEnabledAlertRulesCountSuccess = recordsCount => {
  return {
    type: HOME_ENABLED_ALERT_RULES_COUNT_LOAD_SUCCESS,
    recordsCount
  }
}

export const HOME_ENABLED_ALERT_RULES_COUNT_LOAD_FAILURE =
  'HOME_ENABLED_ALERT_RULES_COUNT_LOAD_FAILURE'
export const loadEnabledAlertRulesCountFailure = error => {
  return {
    type: HOME_ENABLED_ALERT_RULES_COUNT_LOAD_FAILURE,
    error
  }
}

export const HOME_ALERTS_SUMMARY_LOAD = 'HOME_ALERTS_SUMMARY_LOAD'
export const loadAlertsSummary = (accountId: string, projectId: string) => {
  return {
    type: HOME_ALERTS_SUMMARY_LOAD,
    accountId,
    projectId
  }
}

export const HOME_ALERTS_SUMMARY_LOAD_SUCCESS =
  'HOME_ALERTS_SUMMARY_LOAD_SUCCESS'
export const loadAlertsSummarySuccess = recordsCount => {
  return {
    type: HOME_ALERTS_SUMMARY_LOAD_SUCCESS,
    recordsCount
  }
}

export const HOME_ALERTS_SUMMARY_LOAD_FAILURE =
  'HOME_ALERTS_SUMMARY_LOAD_FAILURE'
export const loadAlertsSummaryFailure = error => {
  return {
    type: HOME_ALERTS_SUMMARY_LOAD_FAILURE,
    error
  }
}

type PeriodType = 'total' | 'today' | 'last30Days' | 'assignedToMe'

export interface LoadRecordsCountAction {
  type: typeof HOME_RECORDS_COUNT_LOAD
  accountId: string
  projectId: string
  moduleName: string
  period: PeriodType
  filterState: any
}

export interface LoadEnabledAlertRulesCountAction {
  type: typeof HOME_ENABLED_ALERT_RULES_COUNT_LOAD
  accountId: string
  projectId: string
}

export interface LoadAlertsSummaryAction {
  type: typeof HOME_ALERTS_SUMMARY_LOAD
  accountId: string
  projectId: string
}
